<template>
    <div :class="{section: true, shepherds: true, mobile: mobile()}">
        <img class="hill hill1" src="@/assets/christmas/redHill.svg">
        <img class="hill hill2" src="@/assets/christmas/redHill.svg">
        <img class="grass" src="@/assets/christmas/grass2.svg">
        <img class="shepherdsImg" src="@/assets/christmas/shepherds.svg">
        <div class="ground"></div>
        <p class="text">Die Hirten sind überwältigt von dieser wundersamen Erscheinung und wollen dieser außergewöhnlichen Ankündigung auf den Grund gehen.</p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";

    @Component()
    export default class Shepherds extends BasicComponent {

        onActive() {

        }

        mounted() {
            this.register();
        }



    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .shepherds {

        position: relative;

        background-color: $backgroundBlue;



        .grass {
            max-height: 8vh;
            max-width: 5vw;

            position: absolute;
            bottom: $groundHeight;
            right: 40%;
            transform: translateX(-50%);
        }

        .shepherdsImg {
            max-height: 50vh;
            max-width: 40vw;
            position: absolute;
            bottom: $groundHeight;
            left: 10%;
            z-index: 1200;
        }

        .text {
            text-align: right;
            width: 300px;
            max-width: 35vw;
            position: absolute;
            top: 15vh;
            right: 15%;
            font-weight: normal;
            font-size: 1.6em;
            color: black;
        }

    }

    .mobile {

        .shepherdsImg {
            max-width: 80vw;
            width: 80vw;
            right: 10vw;
            max-height: 40vh;
            transform: none;
            bottom: $mobileGroundHeight
        }

        @media screen and (max-height: 600px) {
            .text {
                font-size: 1.1em !important;
            }
        }

        .hill1 {
            display: none;
        }

        .hill2 {
            transform: translate(30%, calc(32vh + #{$groundHeight}));
        }

    }

</style>
